import httpClient from "../../axios";
import { ENV } from "../../env";

export const DAS_GUESTS = `https://www.${
  ENV !== "production" ? (ENV === "development" ? "dev" : ENV) + "-" : ""
}manage-mii.uk/api/das/guests/`;

const getGuestInfo = async (guestId, eventId) => {
  const response = await httpClient.get(
    DAS_GUESTS + `${guestId}/events/${eventId}`
  );

  return response.data;
};

const guestInfoService = {
  getGuestInfo
};

export default guestInfoService;
